<template>
  <VList
    dense
    class="py-0 px-0"
    dark
    color="transparent"
    :class="{'close' : miniVariant}"
  >
    <VListItem
      v-for="{exact, icon, link, title} in items"
      :key="title"
      link
      :to="link"
      :exact="exact"
      class="menu-item"
      @click="itemSelect()"
    >
      <VListItemContent
        class="d-block"
      >
        <VListItemTitle
          :class="miniVariant
            ? 'd-block' : 'd-flex align-center flex-row justify-start flex-nowrap'"
        >
          <!-- eslint-disable-next-line -->
          <div class="menu-icon" v-html="icon" />
          {{ $t(title) }}
        </VListItemTitle>
      </VListItemContent>
    </VListItem>
  </VList>
</template>

<script>
export default {
  name: 'TheMenuItems',
  props: {
    miniVariant: Boolean,
  },
  data() {
    return {
      items: [
        {
          title: 'panel',
          icon: `
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1099_692)">
                  <path d="M11.9167 11.9167H0V3.25C0 2.38805 0.34241 1.5614 0.951903 0.951903C1.5614 0.34241 2.38805 0 3.25 0L11.9167 0V11.9167ZM2.16667 9.75H9.75V2.16667H3.25C2.96268 2.16667 2.68713 2.2808 2.48397 2.48397C2.2808 2.68713 2.16667 2.96268 2.16667 3.25V9.75Z" fill="white"/>
                  <path d="M26 11.9167H14.0833V0H22.75C23.6119 0 24.4386 0.34241 25.0481 0.951903C25.6576 1.5614 26 2.38805 26 3.25V11.9167ZM16.25 9.75H23.8333V3.25C23.8333 2.96268 23.7192 2.68713 23.516 2.48397C23.3128 2.2808 23.0373 2.16667 22.75 2.16667H16.25V9.75Z" fill="white"/>
                  <path d="M11.9167 26H3.25C2.38805 26 1.5614 25.6576 0.951903 25.0481C0.34241 24.4386 0 23.612 0 22.75L0 14.0833H11.9167V26ZM2.16667 16.25V22.75C2.16667 23.0373 2.2808 23.3129 2.48397 23.516C2.68713 23.7192 2.96268 23.8333 3.25 23.8333H9.75V16.25H2.16667Z" fill="white"/>
                  <path d="M22.75 26H14.0833V14.0833H26V22.75C26 23.612 25.6576 24.4386 25.0481 25.0481C24.4386 25.6576 23.6119 26 22.75 26ZM16.25 23.8333H22.75C23.0373 23.8333 23.3128 23.7192 23.516 23.516C23.7192 23.3129 23.8333 23.0373 23.8333 22.75V16.25H16.25V23.8333Z" fill="white"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_1099_692">
                  <rect width="26" height="26" fill="white"/>
                  </clipPath>
                  </defs>
                </svg>
                `,
          link: { name: 'dashboard' },
          exact: true,
        },
        {
          title: 'aboutCompany',
          icon: `
          <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
           <path d="M20.5833 3.25001H13.5113C13.3438 3.25112 13.1782 3.21407 13.0271 3.14168L9.60808 1.42568C9.15676 1.20093 8.65952 1.08376 8.15533 1.08334H5.41667C3.98061 1.08506 2.60385 1.6563 1.5884 2.67175C0.572955 3.6872 0.00172018 5.06395 0 6.50001L0 19.5C0.00172018 20.9361 0.572955 22.3128 1.5884 23.3283C2.60385 24.3437 3.98061 24.915 5.41667 24.9167H20.5833C22.0194 24.915 23.3961 24.3437 24.4116 23.3283C25.427 22.3128 25.9983 20.9361 26 19.5V8.66668C25.9983 7.23062 25.427 5.85386 24.4116 4.83842C23.3961 3.82297 22.0194 3.25173 20.5833 3.25001ZM5.41667 3.25001H8.15533C8.32288 3.2489 8.48848 3.28595 8.63958 3.35834L12.0586 5.06893C12.5095 5.29555 13.0067 5.41458 13.5113 5.41668H20.5833C21.2312 5.41773 21.864 5.6124 22.4004 5.97569C22.9369 6.33898 23.3525 6.8543 23.5939 7.45551L2.16667 7.57684V6.50001C2.16667 5.63806 2.50908 4.81141 3.11857 4.20191C3.72806 3.59242 4.55471 3.25001 5.41667 3.25001ZM20.5833 22.75H5.41667C4.55471 22.75 3.72806 22.4076 3.11857 21.7981C2.50908 21.1886 2.16667 20.362 2.16667 19.5V9.74351L23.8333 9.62109V19.5C23.8333 20.362 23.4909 21.1886 22.8814 21.7981C22.2719 22.4076 21.4453 22.75 20.5833 22.75Z" fill="white"/>
          </svg>
                  `,
          link: { name: 'company' },
          exact: true,
        },
        {
          title: 'vacancies',
          icon: `<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1129_54)">
                  <path d="M9.75 13C11.0356 13 12.2923 12.6188 13.3612 11.9046C14.4301 11.1903 15.2632 10.1752 15.7552 8.98745C16.2472 7.79973 16.3759 6.49279 16.1251 5.23192C15.8743 3.97104 15.2552 2.81285 14.3462 1.90381C13.4372 0.994768 12.279 0.375703 11.0181 0.124899C9.75721 -0.125905 8.45028 0.00281636 7.26256 0.494786C6.07484 0.986756 5.05968 1.81988 4.34545 2.8888C3.63122 3.95772 3.25 5.21442 3.25 6.5C3.25172 8.22338 3.93709 9.87568 5.15571 11.0943C6.37432 12.3129 8.02662 12.9983 9.75 13ZM9.75 2.16667C10.6071 2.16667 11.4449 2.42082 12.1575 2.89697C12.8701 3.37312 13.4255 4.0499 13.7535 4.84171C14.0815 5.63352 14.1673 6.50481 14.0001 7.34539C13.8329 8.18598 13.4202 8.95811 12.8141 9.56413C12.2081 10.1702 11.436 10.5829 10.5954 10.7501C9.75481 10.9173 8.88352 10.8315 8.09171 10.5035C7.29989 10.1755 6.62312 9.62009 6.14697 8.90747C5.67081 8.19486 5.41667 7.35706 5.41667 6.5C5.41667 5.35073 5.87321 4.24853 6.68587 3.43587C7.49853 2.62322 8.60073 2.16667 9.75 2.16667Z" fill="white"/>
                  <path d="M22.75 10.8333V7.58333H20.5833V10.8333H17.3333V13H20.5833V16.25H22.75V13H26V10.8333H22.75Z" fill="white"/>
                  <path d="M14.1299 15.1667H5.37008C3.94638 15.1684 2.58147 15.7347 1.57476 16.7414C0.568048 17.7481 0.00172015 19.113 0 20.5368L0 26H2.16667V20.5368C2.16753 19.6874 2.50531 18.8731 3.10588 18.2725C3.70645 17.672 4.52075 17.3342 5.37008 17.3333H14.1299C14.9793 17.3342 15.7936 17.672 16.3941 18.2725C16.9947 18.8731 17.3325 19.6874 17.3333 20.5368V26H19.5V20.5368C19.4983 19.113 18.932 17.7481 17.9252 16.7414C16.9185 15.7347 15.5536 15.1684 14.1299 15.1667Z" fill="white"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_1129_54">
                  <rect width="26" height="26" fill="white"/>
                  </clipPath>
                  </defs>
                </svg>
                `,
          link: { name: 'vacancies' },
        },
        {
          title: 'candidates',
          icon: `<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1129_64)">
                  <path d="M13 17.3333C12.1429 17.3333 11.3051 17.0792 10.5925 16.603C9.87992 16.1269 9.3245 15.4501 8.99652 14.6583C8.66854 13.8665 8.58273 12.9952 8.74993 12.1546C8.91713 11.314 9.32984 10.5419 9.93587 9.93587C10.5419 9.32985 11.314 8.91714 12.1546 8.74993C12.9952 8.58273 13.8665 8.66854 14.6583 8.99652C15.4501 9.3245 16.1269 9.87992 16.603 10.5925C17.0792 11.3051 17.3333 12.143 17.3333 13C17.3333 14.1493 16.8768 15.2515 16.0641 16.0641C15.2515 16.8768 14.1493 17.3333 13 17.3333ZM13 10.8333C12.5715 10.8333 12.1526 10.9604 11.7963 11.1985C11.44 11.4366 11.1623 11.7749 10.9983 12.1709C10.8343 12.5668 10.7914 13.0024 10.875 13.4227C10.9586 13.843 11.1649 14.2291 11.4679 14.5321C11.771 14.8351 12.157 15.0414 12.5773 15.125C12.9976 15.2086 13.4332 15.1657 13.8291 15.0017C14.2251 14.8378 14.5634 14.56 14.8015 14.2037C15.0396 13.8474 15.1667 13.4285 15.1667 13C15.1667 12.4254 14.9384 11.8743 14.5321 11.4679C14.1257 11.0616 13.5746 10.8333 13 10.8333ZM19.5 24.9167C19.5 23.1928 18.8152 21.5395 17.5962 20.3205C16.3772 19.1015 14.7239 18.4167 13 18.4167C11.2761 18.4167 9.62279 19.1015 8.40381 20.3205C7.18482 21.5395 6.5 23.1928 6.5 24.9167C6.5 25.204 6.61414 25.4795 6.8173 25.6827C7.02047 25.8859 7.29602 26 7.58333 26C7.87065 26 8.1462 25.8859 8.34937 25.6827C8.55253 25.4795 8.66667 25.204 8.66667 24.9167C8.66667 23.7674 9.12321 22.6652 9.93587 21.8525C10.7485 21.0399 11.8507 20.5833 13 20.5833C14.1493 20.5833 15.2515 21.0399 16.0641 21.8525C16.8768 22.6652 17.3333 23.7674 17.3333 24.9167C17.3333 25.204 17.4475 25.4795 17.6506 25.6827C17.8538 25.8859 18.1293 26 18.4167 26C18.704 26 18.9795 25.8859 19.1827 25.6827C19.3859 25.4795 19.5 25.204 19.5 24.9167ZM19.5 8.66667C18.6429 8.66667 17.8051 8.41252 17.0925 7.93637C16.3799 7.46022 15.8245 6.78344 15.4965 5.99163C15.1685 5.19982 15.0827 4.32853 15.2499 3.48794C15.4171 2.64736 15.8298 1.87523 16.4359 1.26921C17.0419 0.663178 17.814 0.250468 18.6546 0.0832657C19.4952 -0.0839369 20.3665 0.00187755 21.1583 0.329857C21.9501 0.657837 22.6269 1.21325 23.103 1.92586C23.5792 2.63848 23.8333 3.47628 23.8333 4.33334C23.8333 5.48261 23.3768 6.58481 22.5641 7.39747C21.7515 8.21012 20.6493 8.66667 19.5 8.66667ZM19.5 2.16667C19.0715 2.16667 18.6526 2.29374 18.2963 2.53182C17.94 2.76989 17.6623 3.10828 17.4983 3.50419C17.3343 3.90009 17.2914 4.33574 17.375 4.75603C17.4586 5.17632 17.6649 5.56239 17.9679 5.8654C18.271 6.16841 18.657 6.37477 19.0773 6.45837C19.4976 6.54197 19.9332 6.49906 20.3291 6.33507C20.7251 6.17108 21.0634 5.89338 21.3015 5.53707C21.5396 5.18076 21.6667 4.76186 21.6667 4.33334C21.6667 3.7587 21.4384 3.2076 21.0321 2.80127C20.6257 2.39494 20.0746 2.16667 19.5 2.16667ZM26 16.25C25.9983 14.5266 25.3129 12.8743 24.0943 11.6557C22.8757 10.4371 21.2234 9.75172 19.5 9.75C19.2127 9.75 18.9371 9.86414 18.734 10.0673C18.5308 10.2705 18.4167 10.546 18.4167 10.8333C18.4167 11.1207 18.5308 11.3962 18.734 11.5994C18.9371 11.8025 19.2127 11.9167 19.5 11.9167C20.6493 11.9167 21.7515 12.3732 22.5641 13.1859C23.3768 13.9985 23.8333 15.1007 23.8333 16.25C23.8333 16.5373 23.9475 16.8129 24.1506 17.016C24.3538 17.2192 24.6293 17.3333 24.9167 17.3333C25.204 17.3333 25.4795 17.2192 25.6827 17.016C25.8859 16.8129 26 16.5373 26 16.25ZM6.5 8.66667C5.64295 8.66667 4.80514 8.41252 4.09253 7.93637C3.37992 7.46022 2.8245 6.78344 2.49652 5.99163C2.16854 5.19982 2.08273 4.32853 2.24993 3.48794C2.41713 2.64736 2.82984 1.87523 3.43587 1.26921C4.0419 0.663178 4.81402 0.250468 5.65461 0.0832657C6.49519 -0.0839369 7.36648 0.00187755 8.15829 0.329857C8.95011 0.657837 9.62688 1.21325 10.103 1.92586C10.5792 2.63848 10.8333 3.47628 10.8333 4.33334C10.8333 5.48261 10.3768 6.58481 9.56413 7.39747C8.75147 8.21012 7.64927 8.66667 6.5 8.66667ZM6.5 2.16667C6.07147 2.16667 5.65257 2.29374 5.29627 2.53182C4.93996 2.76989 4.66225 3.10828 4.49826 3.50419C4.33427 3.90009 4.29136 4.33574 4.37497 4.75603C4.45857 5.17632 4.66492 5.56239 4.96794 5.8654C5.27095 6.16841 5.65701 6.37477 6.0773 6.45837C6.4976 6.54197 6.93324 6.49906 7.32915 6.33507C7.72505 6.17108 8.06344 5.89338 8.30152 5.53707C8.53959 5.18076 8.66667 4.76186 8.66667 4.33334C8.66667 3.7587 8.43839 3.2076 8.03207 2.80127C7.62574 2.39494 7.07464 2.16667 6.5 2.16667ZM2.16667 16.25C2.16667 15.1007 2.62321 13.9985 3.43587 13.1859C4.24853 12.3732 5.35073 11.9167 6.5 11.9167C6.78732 11.9167 7.06287 11.8025 7.26603 11.5994C7.4692 11.3962 7.58333 11.1207 7.58333 10.8333C7.58333 10.546 7.4692 10.2705 7.26603 10.0673C7.06287 9.86414 6.78732 9.75 6.5 9.75C4.77662 9.75172 3.12432 10.4371 1.90571 11.6557C0.687093 12.8743 0.0017208 14.5266 0 16.25C0 16.5373 0.114137 16.8129 0.317301 17.016C0.520465 17.2192 0.796016 17.3333 1.08333 17.3333C1.37065 17.3333 1.6462 17.2192 1.84937 17.016C2.05253 16.8129 2.16667 16.5373 2.16667 16.25Z" fill="white"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_1129_64">
                  <rect width="26" height="26" fill="white"/>
                  </clipPath>
                  </defs>
                </svg>
                  `,
          link: { name: 'candidates-list' },
        },
        {
          title: 'qr',
          icon: `<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1099_708)">
                    <path d="M0 11.9167H11.9167V0H0V11.9167ZM2.16667 2.16667H9.75V9.75H2.16667V2.16667ZM4.33333 4.33333H7.58333V7.58333H4.33333V4.33333ZM26 0H14.0833V11.9167H26V0ZM23.8333 9.75H16.25V2.16667H23.8333V9.75ZM21.6667 7.58333H18.4167V4.33333H21.6667V7.58333ZM0 26H11.9167V14.0833H0V26ZM2.16667 16.25H9.75V23.8333H2.16667V16.25ZM4.33333 18.4167H7.58333V21.6667H4.33333V18.4167ZM18.4167 14.0833V18.4167H14.0833V14.0833H18.4167ZM18.4167 18.4167H21.6667V21.6667H18.4167V18.4167ZM14.0833 21.6667H18.4167V26H14.0833V21.6667ZM26 14.0833V18.4167H21.6667V14.0833H26Z" fill="white"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_1099_708">
                    <rect width="26" height="26" fill="white"/>
                    </clipPath>
                    </defs>
                  </svg>
                `,
          link: { name: 'qr-list' },
        },
        {
          title: 'careerPortal',
          icon: `<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1129_2)">
                    <path d="M20.5833 4.33333H19.3917C19.1402 3.1107 18.475 2.01213 17.508 1.22278C16.5411 0.433431 15.3316 0.00157573 14.0833 0L11.9167 0C10.6684 0.00157573 9.45893 0.433431 8.49198 1.22278C7.52503 2.01213 6.85977 3.1107 6.60833 4.33333H5.41667C3.98061 4.33505 2.60385 4.90629 1.5884 5.92174C0.572955 6.93719 0.00172018 8.31394 0 9.75L0 20.5833C0.00172018 22.0194 0.572955 23.3961 1.5884 24.4116C2.60385 25.427 3.98061 25.9983 5.41667 26H20.5833C22.0194 25.9983 23.3961 25.427 24.4116 24.4116C25.427 23.3961 25.9983 22.0194 26 20.5833V9.75C25.9983 8.31394 25.427 6.93719 24.4116 5.92174C23.3961 4.90629 22.0194 4.33505 20.5833 4.33333ZM11.9167 2.16667H14.0833C14.7531 2.16944 15.4057 2.37909 15.9518 2.76693C16.4978 3.15477 16.9107 3.70185 17.134 4.33333H8.866C9.08926 3.70185 9.50217 3.15477 10.0482 2.76693C10.5943 2.37909 11.2469 2.16944 11.9167 2.16667ZM5.41667 6.5H20.5833C21.4453 6.5 22.2719 6.84241 22.8814 7.4519C23.4909 8.0614 23.8333 8.88805 23.8333 9.75V13H2.16667V9.75C2.16667 8.88805 2.50908 8.0614 3.11857 7.4519C3.72806 6.84241 4.55471 6.5 5.41667 6.5ZM20.5833 23.8333H5.41667C4.55471 23.8333 3.72806 23.4909 3.11857 22.8814C2.50908 22.2719 2.16667 21.4453 2.16667 20.5833V15.1667H11.9167V16.25C11.9167 16.5373 12.0308 16.8129 12.234 17.016C12.4371 17.2192 12.7127 17.3333 13 17.3333C13.2873 17.3333 13.5629 17.2192 13.766 17.016C13.9692 16.8129 14.0833 16.5373 14.0833 16.25V15.1667H23.8333V20.5833C23.8333 21.4453 23.4909 22.2719 22.8814 22.8814C22.2719 23.4909 21.4453 23.8333 20.5833 23.8333Z" fill="white"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_1129_2">
                    <rect width="26" height="26" fill="white"/>
                    </clipPath>
                    </defs>
                  </svg>
                  `,
          link: { name: 'career-portal' },
        },
        //         {
        //           title: 'partnership',
        //           icon: `
        // <svg width="47.608px" height="47.608px" viewBox="0 -5.34 47.608 47.608" xmlns="http://www.w3.org/2000/svg"><g transform="translate(-629.25 -210.949)"><path d="M665.8,233.227l2.18,2.181a2.215,2.215,0,0,1,0,3.134h0a2.215,2.215,0,0,1-3.134,0l-1.521-1.52" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M662.664,236.362l3.5,3.5a2.218,2.218,0,0,1,0,3.135h0a2.216,2.216,0,0,1-3.135,0l-3.5-3.5" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M658.65,238.617l3.72,3.72a2.218,2.218,0,0,1,0,3.135h0a2.218,2.218,0,0,1-3.135,0l-3.72-3.72" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M654.635,240.872l2.09,2.09a2.276,2.276,0,0,1-.083,3.217h0a2.277,2.277,0,0,1-3.217.082l-1.567-1.567" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><line x2="10.899" y2="10.899" transform="translate(654.9 222.328)" stroke-width="1.5" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" fill="none"/><path d="M639.061,231.9l-9.311-9.311,9.8-9.67,4.472,4.473a19.473,19.473,0,0,1,9.237.149" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><rect width="4.433" height="7.019" rx="2.127" transform="translate(649.376 247.176) rotate(-135)" stroke-width="1.5" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" fill="none"/><rect width="4.433" height="8.208" rx="2.127" transform="translate(645.741 244.026) rotate(-135)" stroke-width="1.5" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" fill="none"/><rect width="4.433" height="8.208" rx="2.127" transform="translate(639.472 237.756) rotate(-135)" stroke-width="1.5" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" fill="none"/><rect width="4.433" height="9.836" rx="2.127" transform="translate(642.031 241.467) rotate(-135)" stroke-width="1.5" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" fill="none"/><path d="M665.139,231.908l11.219-11.219-9.239-9.24-7.974,8.195s-5.307-3.658-8.277-1.348A39.55,39.55,0,0,1,646.879,221a2.512,2.512,0,0,0-.991,3.2h0a2.52,2.52,0,0,0,3.463,1.19l5.219-2.734" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></g></svg>
        // `,
        //           link: { name: 'partnership' },
        //         },
      ],
    };
  },
  methods: {
    itemSelect() {
      this.$emit('itemSelect');
    },
  },
};
</script>

<style lang="scss" scoped>
  .menu-item {
    text-align: center;
    &::after {
      display: none;
    }
  }

  .v-list::-webkit-scrollbar {
      width: 5px;
    }
  .v-list::v-deep {
    overflow-x: hidden;
    overflow-y: hidden;
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #42aaff;
      border-radius: 20px;
    }
    @media screen and (max-height: 670px) {
      max-height: 360px;
      overflow-y: auto;
    }
    @media screen and (max-height: 580px) {
      max-height: 294px;
      overflow-y: auto;
    }
    @media screen and (max-height: 510px) {
      max-height: 216px;
      overflow-y: auto;
    }
    a:nth-child(6) {
      .v-list-item__title {
      white-space: normal;
    }
  }
  .v-list-item {
    @media screen and (max-width: 599px) {
      padding: 0 8px !important;
      &:nth-child(1) {
        padding: 20px 8px 0 !important;
      }
    }
  }
  .v-list-item__content {
    padding: 10px !important;
    @media screen and (max-width: 1650px) {
      padding: 5px !important;
    }
    @media screen and (max-width: 600px) {
      padding: 3px 12px 3px 12px !important;
    }
    @media screen and (max-width: 320px) {
      padding: 0px 7px 0px 7px !important;
    }
    .v-list-item__title {
      @media screen and (max-width: 599px) {
        font-weight: 600;
        font-size: 24px;
        line-height: 100%;
      }
      @media screen and (max-width: 320px) {
        font-size: 18px;
      }
      .menu-icon {
        @media screen and (max-width: 599px) {
          width: 18px;
        }
      }
    }
  }
}

</style>

<i18n locale="en" lang="yaml">
  panel: Dashboard
  aboutCompany: Company
  careerPortal: Portal
  vacancies: Jobs
  qr: QR codes
  partnership: Partnership
  candidates: Candidates
</i18n>

<i18n locale="ru" lang="yaml">
  panel: Панель
  aboutCompany: О компании
  careerPortal: Карьерный портал
  vacancies: Вакансии
  qr: QR codes
  partnership: Партнерам
  candidates: Кандидаты
</i18n>
